import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { GoogleAuthSetupStepComponent } from 'app/components/v2-layout/shared/two-factor-setup-steps/google-auth-setup-step.component';

/**
 * Settings → Security wrapper: hosts the shared {@link GoogleAuthSetupStepComponent}
 * inside a dialog so authenticator enrollment is identical to the 2FA gate stepper and
 * the enrollment logic lives in exactly one place. Preserves the existing
 * open()/afterClosed contract — resolves `{success: true}` once enrolled and `undefined`
 * on cancel — so the Settings tab is unchanged (SD-8102).
 */
@Component({
    selector: 'app-setup-google-authenticator',
    templateUrl: './setup-google-authenticator.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatDialogModule,
        GoogleAuthSetupStepComponent,
    ],
})
export class SetupGoogleAuthenticatorComponent
{
    constructor(private _dialogRef: MatDialogRef<SetupGoogleAuthenticatorComponent>) {
    }

    onCompleted(): void {
        this._dialogRef.close({success: true});
    }

    onCancelled(): void {
        this._dialogRef.close();
    }
}
